var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 98C97.1472 98 77 116.837 77 140.074V257.882C77 281.119 97.1472 299.957 122 299.957H329C353.853 299.957 374 281.119 374 257.882V140.074C374 116.837 353.853 98 329 98H122ZM142 144.749C133.716 144.749 127 151.028 127 158.774V239.183C127 246.928 133.716 253.207 142 253.207H309C317.284 253.207 324 246.928 324 239.183V158.774C324 151.028 317.284 144.749 309 144.749H142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471 500.043C446.147 500.043 426 518.881 426 542.118V659.926C426 683.163 446.147 702 471 702H678C702.853 702 723 683.163 723 659.926V542.118C723 518.881 702.853 500.043 678 500.043H471ZM491 546.793C482.716 546.793 476 553.072 476 560.817V641.226C476 648.972 482.716 655.251 491 655.251H658C666.284 655.251 673 648.972 673 641.226V560.817C673 553.072 666.284 546.793 658 546.793H491Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471 98C446.147 98 426 116.837 426 140.074V409.35C426 432.587 446.147 451.424 471 451.424H678C702.853 451.424 723 432.587 723 409.35V140.074C723 116.837 702.853 98 678 98H471ZM491 144.749C482.716 144.749 476 151.028 476 158.774V390.65C476 398.396 482.716 404.675 491 404.675H658C666.284 404.675 673 398.396 673 390.65V158.774C673 151.028 666.284 144.749 658 144.749H491Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 348.576C97.1472 348.576 77 367.413 77 390.65V659.926C77 683.163 97.1472 702 122 702H329C353.853 702 374 683.163 374 659.926V390.65C374 367.413 353.853 348.576 329 348.576H122ZM142 395.325C133.716 395.325 127 401.604 127 409.35V641.226C127 648.972 133.716 655.251 142 655.251H309C317.284 655.251 324 648.972 324 641.226V409.35C324 401.604 317.284 395.325 309 395.325H142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.9e9669bf7841810c9e864c7ec169d42b.svg";
export { ForwardRef as ReactComponent };